import { useEffect, useState } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Card from "@mui/material/Card"
import CardMedia from "@mui/material/CardMedia"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import CircularProgress from "@mui/material/CircularProgress"
import Alert from "@mui/material/Alert"
import { useWallet } from "@solana/wallet-adapter-react"
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui"
import { useOwnedApes } from "./useOwnedApes"
import ApeTraits, { loadApeIndex, RankChip } from "./ApeTraits"
import Carousel from "./Carousel"
import Downloads from "./Downloads"

const Empty = ({ text, button }: { text: string, button?: boolean }) => (
	<Card sx={{ p: 5, textAlign: "center", bgcolor: "rgba(255,255,255,.7)" }}>
		<Typography color="text.secondary" sx={{ mb: button ? 2 : 0 }}>{text}</Typography>
		{button && <Box sx={{ display: "inline-block" }}><WalletMultiButton /></Box>}
	</Card>
)

const MyApes = () => {
	const { publicKey } = useWallet()
	const { apes, error, loading } = useOwnedApes()
	const [dnas, setDnas] = useState<string[]>()

	useEffect(() => {
		if (apes?.length) loadApeIndex().then(i => setDnas(i.map(a => a[0]))).catch(() => undefined)
	}, [apes])

	if (!publicKey) return <Empty text="Connect your wallet to see your apes' traits and rarity rank." button />
	if (loading) return <CircularProgress sx={{ display: "block", mx: "auto" }} />
	if (error) return <Alert severity="error">Couldn't load your apes: {error}</Alert>
	if (!apes?.length) return <Empty text="No Bored Ape Pastels found in this wallet." />

	return (
		<Carousel label="Your apes">
			{apes.map(ape => (
				<Card key={ape.id} sx={{ display: "flex", flexDirection: "column" }}>
					<CardMedia component="img" image={ape.image} alt={ape.name} sx={{ aspectRatio: "1" }} />
					<CardContent sx={{ flexGrow: 1 }}>
						<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 2 }}>
							<Typography variant="h6" sx={{ fontWeight: 700 }}>{ape.name}</Typography>
							<RankChip number={ape.number} />
						</Box>
						<ApeTraits attributes={ape.attributes} />
						{dnas?.[ape.number] && <Box sx={{ mt: 2.5 }}><Downloads ape={ape} dna={dnas[ape.number]} /></Box>}
					</CardContent>
					{dnas?.[ape.number] && <Button href={`/${dnas[ape.number]}`} sx={{ m: 2, mt: 0 }} variant="outlined">Public page</Button>}
				</Card>
			))}
		</Carousel>
	)
}

export default MyApes
